module.exports = __webpack_public_path__ + "static/media/otto.e7aff4e7.png";